import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SimpleSelectComponent } from './simple-select.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    declarations: [
        SimpleSelectComponent,
    ],
    exports: [
        SimpleSelectComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule
    ]
})
export class SimpleSelectModule { }
